module.exports = __webpack_public_path__ + "static/media/side-fudr.4cda1d56.svg";